// modules
import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { useStore } from 'modules/Stores';
import AnalyticsService from 'modules/Analytics/service';
// components
import { Button, View, Text, Checkbox } from '@upstox/upstox-ui';
import { EVENTS } from 'modules/Analytics/consts';
import BrowsersList from './components/BrowsersList';
// consts
// styles
import * as css from './styles';

type TProps = {
  onClose: (dontShowMessageAgain: boolean) => void;
};

const UnsupportedBrowserAlert: React.FC<TProps> = ({ onClose }) => {
  const [dontShowMessageAgain, setDontShowMessageAgain] = useState(false);

  const { profile } = useStore('UserStore');

  const { theme } = useStore('AppStore');

  const { logout } = useStore('AuthStore');

  const userName = useMemo(() => {
    if (!profile || !profile.firstName) {
      return '';
    }
    const firstName = profile?.firstName;
    return firstName?.charAt(0) + firstName?.slice(1)?.toLocaleLowerCase();
  }, [profile]);

  const sendMixpanelEvent = useCallback(
    (eventType: EVENTS) => {
      AnalyticsService.sendEvent(
        eventType,
        {},
        true,
      );
    },
    [],
  );

  useEffect(() => {
    sendMixpanelEvent(EVENTS.BROWSER_WARNING_VIEWED);
  }, [sendMixpanelEvent]);

  const onDontShowMessageChecked = () => {
    sendMixpanelEvent(EVENTS.BROWSER_WARNING_CLOSED);
    setDontShowMessageAgain(!dontShowMessageAgain);
  };

  const onContinueClick = () => {
    sendMixpanelEvent(EVENTS.BROWSER_WARNING_CONTINUE);
    onClose(dontShowMessageAgain);
  };

  const onLogoutClick = () => {
    sendMixpanelEvent(EVENTS.BROWSER_WARNING_LOGOUT);
    logout(true);
  };

  return (
    <View flexDirection="column" css={css.wrapper}>
      <View css={css.innerCard} cssProps={{ currentTheme: theme }}>
        <View flexDirection="column" css={css.topContainer}>
          <Text css={css.headerText} cssProps={{ currentTheme: theme }}>
            {`Hey ${userName},`}
          </Text>
          <Text
            css={css.headerText}
            cssProps={{ isBold: true, currentTheme: theme }}
          >
            your current browser isn&apos;t supported
          </Text>

          <View css={css.subHeaderTextContainer}>
            <Text css={css.subHeaderText}>
              We recommend you to use one of these supported browsers for a
              faster and better trading experience.
            </Text>
          </View>
          <BrowsersList />
        </View>

        <View
          flex
          flexDirection="column"
          css={css.bottomContainer}
          cssProps={{ currentTheme: theme }}
        >
          <Text css={css.warningText} cssProps={{ currentTheme: theme }}>
            Continuing with an unsupported browser may result in a poor trading
            experience.
          </Text>
          <View
            flex
            flexDirection="row"
            css={css.buttonContainer}
            cssProps={{ currentTheme: theme }}
          >
            <Button
              size="large"
              variant="secondary"
              onClick={onContinueClick}
              width="full"
            >
              Continue anyway
            </Button>
            <Button
              size="large"
              variant="primary"
              onClick={onLogoutClick}
              width="full"
            >
              Logout
            </Button>
          </View>

          <View
            alignItems="center"
            css={css.rememberCheckBox}
            onClick={onDontShowMessageChecked}
            cssProps={{ currentTheme: theme }}
          >
            <Checkbox
              readOnly
              checked={dontShowMessageAgain}
              isSquare
              className="checkboxIcon"
            />
            <Text
              css={css.rememberCheckBoxText}
              cssProps={{ currentTheme: theme }}
            >
              Don’t show this message again
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
};

export default React.memo(UnsupportedBrowserAlert);
